import { defineMessages } from "react-intl";
const messages = defineMessages({
    pointsOfInterestTitle: {
        id: "app.aiDiscoverability.customSubtopics.locationTab.pointsOfInterest.title",
        defaultMessage: "Points of interest",
    },
    pointsOfInterestSubtitle: {
        id: "app.aiDiscoverability.customSubtopics.locationTab.pointsOfInterest.subtitle",
        defaultMessage: 'How these are used: "I am looking for an apartment to rent near [Central Park]"',
    },
    neighborhoodTitle: {
        id: "app.aiDiscoverability.customSubtopics.locationTab.neighborhood.title",
        defaultMessage: "Neighborhood",
    },
    neighborhoodSubtitle: {
        id: "app.aiDiscoverability.customSubtopics.locationTab.neighborhood.subtitle",
        defaultMessage: 'How these are used: "I am looking for an apartment to rent around [Williamsburg]"',
    },
});
export default messages;
